// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import ReactGA from "react-ga4";
import "./index.css";

import App from "./App";
import { AppKitProvider } from "./AppKitProvider"; // Adjust the path as needed

// Initialize GA as before…
const initializeGA = () => {
  if (process.env.NODE_ENV === "production") {
    ReactGA.initialize("G-MQ9JCS2MFW", {
      gaOptions: { anonymize_ip: true },
      debug: false,
    });
    console.log("GA Initialized in Production");
  } else {
    console.log("GA Not Initialized (Development Mode)");
  }
};
initializeGA();

const root = ReactDOM.createRoot(document.getElementById("root"));



root.render(
  <AppKitProvider>
    <BrowserRouter basename="/dashboard">
      <App />
    </BrowserRouter>
  </AppKitProvider>
);
